import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { registerErrorLogTokenAccessor } from "@/lib/errorLoggingACTIONS";

// The root ErrorBoundary wraps Auth0Provider, so it cannot call useAuth0 to
// get a token for POST /Logs. This sits inside the provider and hands the
// token accessor to errorLoggingACTIONS for logAppRootError. (LQC-1841)
export function ErrorLogTokenRegistrar() {
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    registerErrorLogTokenAccessor(getAccessTokenSilently);
  }, [getAccessTokenSilently]);

  return null;
}
